/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useBreakpointContext } from "../../../../components/BreakpointProvider";
var Desktop = function Desktop(_ref) {
  var children = _ref.children;
  var _useBreakpointContext = useBreakpointContext(),
    isDesktop = _useBreakpointContext.isDesktop;
  return isDesktop ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};
var Mobile = function Mobile(_ref2) {
  var children = _ref2.children;
  var _useBreakpointContext2 = useBreakpointContext(),
    isMobile = _useBreakpointContext2.isMobile,
    isTablet = _useBreakpointContext2.isTablet;
  return isMobile || isTablet ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};
export var View = {
  Desktop: Desktop,
  Mobile: Mobile
};